import {
  MediaData,
  HotSpotNodeData,
  HotSpotData,
  HotSpotMediaData,
} from '../../../types/quiz';
import { parseMainExp, parseStringWithNode } from './utils';

/**
 * HotSpotData.
 */
export const mapHotSpotData = ({
  data,
  mediaData,
}: {
  data: HotSpotNodeData;
  mediaData: MediaData<HotSpotMediaData[]>;
}): HotSpotData => {
  const keyTakeaway = parseMainExp(data.kp);
  const mainExplanation = parseMainExp(data.e);
  return {
    question: `${process.env.NEXT_PUBLIC_S3_BUCKET_URL}/${data.q}`,
    directions: parseStringWithNode(data.directions, mediaData),
    mainExplanation,
    keyTakeaway,
    answers: {
      area: data.a?.[0]?.area ?? [],
      text: data.a?.[0]?.text ?? '',
    },
  };
};
